import scroll_down from "../../_assets/images/scroll_down.png";
import { NavLink } from "react-router-dom";
import { Container, MainContainer } from "../ComponentCss";

const QAMainComponent = () => {
    return (
        <MainContainer>
            <Container className="qa-cont">
                <nav>
                    <NavLink to="/">ASMR 체험하기</NavLink>
                    <NavLink to="?step=qna" className="active-tab">반전문답 확인하기</NavLink>
                </nav>
                <div className="main-inner">
                    <div className="main-comm" style={{ marginTop: "-20rem" }}>
                        <h1>
                            같은 나이, 다른 상황<br />
                            아이들의 세상은 얼마나 다를까요?
                        </h1>
                        <p style={{ marginTop: "3rem" }}>
                            어렸을 적 당신이 듣고 자란 이야기와<br />
                            아이들이 듣는 이야기는 <br className="mo" />어떻게 다른지 정답을 맞혀주세요
                        </p>
                    </div>
                </div>
                <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img" />
                <span className="copyright">©UNICEF/ UN0308114/ Zaidi</span>
            </Container>         
        </MainContainer>
    );
}

export default QAMainComponent;
